/**
 * Configurable routing: NC-path (tiles only) vs below-NC (routine template + timetable).
 */

import { ROUTINE_TIMETABLE_NC_STATUSES } from './teachingPlanConfig';

export const TEACHING_PLAN_ROUTING = {
  routineTimetableNcStatuses: ROUTINE_TIMETABLE_NC_STATUSES,
};

export function getTeachingPlanPath(ncStatus) {
  if (ncStatus && TEACHING_PLAN_ROUTING.routineTimetableNcStatuses.includes(ncStatus)) {
    return 'below_nc_routine';
  }
  return 'nc_interventions';
}

export function usesRoutineTimetable(ncStatus) {
  return getTeachingPlanPath(ncStatus) === 'below_nc_routine';
}

export function ncPathHeading(studentName) {
  return `These are activities and strategies to fit into ${studentName}'s existing class timetable.`;
}
